export default {
    partLoading: state => state.partLoading,
    partsListLoading: state => state.partsListLoading,
    partsList: state => state.partsList,
}